import {faPen, faToggleOff, faToggleOn} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import MyIconButton from 'components/Layout/MyIconButton';
import MyDialog from 'components/Layout/MyDialog';
import {logError} from 'components/Utils/FormatData';
import {URL_API} from 'utils/globalConfig';
import useAuthz from 'hooks/useAuthz';
import React, {useEffect, useState} from 'react';
import {useAlert} from 'react-alert';

const actionsEPRenderer = (props) => {
	const alert = useAlert();
	const [authz, user, profil] = useAuthz();
	const [content, setContent] = useState('');
	const [dialogData, setDialogData] = useState({type: '', data: {}});
	const [dialogState, setDialogState] = useState();
	const [openDialog, setOpenDialog] = useState(false);

	useEffect(() => {
		if (dialogState && dialogData.data) {

			switch (dialogData.type) {
				case 'delete':
					axios({method: 'delete', url: `${URL_API}/element-patrimoine/deactivate`, params: {id: dialogData.data.id, userAction: user.user_id}})
						.then(() => {
							alert.success(`Cet élément patrimoine [${dialogData.data.id}] a été désactivé avec succès`);
							props.setNeedReloadDatas(true);
						})
						.catch((err) => {
							logError(alert, err);
						});
					break;
				case 'reactivate':
					axios({method: 'put', url: `${URL_API}/element-patrimoine/activate`, params: {id: dialogData.data.id, userAction: user.user_id}})
						.then(() => {
							alert.success(`Cet élément patrimoine [${dialogData.data.id}] a bien été réactivé`);
							props.setNeedReloadDatas(true);
						})
						.catch((err) => {
							logError(alert, err);
						});
					break;
			}

			setDialogData({type: '', data: {}});
			setDialogState(null);
		}
	}, [dialogState]);

	//#region Functions

	const desactivateElementPatrimoine = () => {
		if (props.data) {
			setDialogData({...dialogData, data: props.data, type: 'delete'});
			setContent(() => {
				return (
					<>
						<div>Êtes-vous sûr de vouloir désactiver cet élément patrimoine <b>{props.data.id}</b> ?</div>
					</>
				)
			});
			setOpenDialog(true);
		}
	};
	const reactivateElementPatrimoine = () => {
		if (props.data) {
			setDialogData({...dialogData, data: props.data, type: 'reactivate'});
			setContent(() => {
				return (
					<>
						<div>Êtes-vous sûr de vouloir réactiver cet élément patrimoine <b>{props.data.id}</b> ?</div>
					</>
				)
			});
			setOpenDialog(true);
		}
	};

	//#endregion

	return (
		<div style={{width: '100%'}}>
			{
				!props.data.deleted && <MyIconButton className='classic-button' type='button' href='#' iconCenter={{icon: faToggleOn, type: 'fontAwesome'}}
																						 styleCss={{boxShadow: 'none', color: '#0094ca', height: '20px', margin: '5px'}}
																						 onClick={() => desactivateElementPatrimoine()}/>
			}
			{
				props.data.deleted && <MyIconButton className='classic-button' type='button' href='#' iconCenter={{icon: faToggleOff, type: 'fontAwesome'}}
																						styleCss={{boxShadow: 'none', color: '#0094ca', height: '20px', margin: '5px'}}
																						onClick={() => reactivateElementPatrimoine()}/>
			}
			{
				!props.data.deleted && <MyIconButton className='classic-button' type='button' iconCenter={{icon: faPen, type: 'fontAwesome'}}
																						 styleCss={{boxShadow: 'none', color: '#bb0060', height: '20px', margin: '5px'}}
																						 href={`/panneau-administration/elements-patrimoines/edition?id=${props.data.id}`}/>
			}

			<MyDialog open={openDialog} handleClose={setOpenDialog} title='Gestion des éléments patrimoines' content={content} dialog={setDialogState}/>
		</div>
	);

};

export default actionsEPRenderer;
